import React, { useEffect } from 'react';
import { Alert } from '@interstate/components/Alert';
import type { MessageBannerConfig } from '../../types/AuditLog';
import { BannerWrapper } from './MessageBanner.style';
import { BANNER_WARNING_DELAY } from '../../types/AuditLog';

const Banner: React.FC<MessageBannerConfig> = ({ alertSeverity, title, description }) => {
    // hide the banner after some time
    const [isVisible, setIsVisible] = React.useState(true);
    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(false);
        }, BANNER_WARNING_DELAY);
        return () => clearTimeout(timer);
    }, []);

    if (!isVisible) return null;

    return (
        <BannerWrapper className="isBaseDeal">
            <Alert
                type={alertSeverity}
                key={`alert-message`}
                role="version-banner-message"
                data-testid={`alert-message`}
                title={title}
            >
                {description}
            </Alert>
        </BannerWrapper>
    );
};

export default Banner;
